export enum RegenerateReportLinkWizardStep {
  LinkNameStep,
  RestrictionsStep,
  PreviousRecipientsStep,
  RecipientsStep,
  ReviewStep,
  ShareReportStep,
}

export const REGENERATE_REPORT_LINK_WIZARD_LABELS: Record<
  RegenerateReportLinkWizardStep,
  string
> = {
  [RegenerateReportLinkWizardStep.LinkNameStep]: "Link name",
  [RegenerateReportLinkWizardStep.RestrictionsStep]: "Restrictions",
  [RegenerateReportLinkWizardStep.PreviousRecipientsStep]:
    "Previous recipients",
  [RegenerateReportLinkWizardStep.RecipientsStep]: "Recipients",
  [RegenerateReportLinkWizardStep.ReviewStep]: "Review",
  [RegenerateReportLinkWizardStep.ShareReportStep]: "Share report",
};
